import { useTranslations } from "use-intl";
import { Badge } from "@/components/catalyst/badge";
import { IncidentClosedOutcome, IncidentStatus } from "@/gql/graphql";
import {
  incidentOutcomeColorMap,
  incidentStatusColorMap,
} from "@/app/Incidents/Utils/incidentColorMaps";

export function IncidentStatusBadge({
  status,
  outcome,
}: {
  status: IncidentStatus;
  outcome: IncidentClosedOutcome | null;
}) {
  const t = useTranslations("incident");

  return outcome ? (
    <Badge color={incidentOutcomeColorMap[outcome]}>
      {t(`closedOutcome.${outcome}`)}
    </Badge>
  ) : (
    <Badge color={incidentStatusColorMap[status]}>
      {t(`status.${status}`)}
    </Badge>
  );
}
